import { VariantProps, cva } from 'class-variance-authority'

interface ErrorLayoutProps extends VariantProps<typeof variants> {
  children: React.ReactNode
  className?: string
}

export function ErrorLayout({ children, fullScreen, className }: ErrorLayoutProps) {
  return <div className={variants({ fullScreen, className })}>{children}</div>
}

const variants = cva('flex w-full grow flex-col items-center justify-center gap-6 pt-8', {
  variants: {
    fullScreen: {
      true: 'min-h-screen',
    },
  },
})
